<div class="work-tablesoccer-counter">
  <div class="padding-24 flex flex-row space-between">
    <div class="flex flex-row gap-16 vertical-center">
      <work-ui-logo variant="white" />
      <h1 class="margin-top-8">Töggelichaschte</h1>
    </div>
    <button (click)="reload()" class="work-tablesoccer-button work-tablesoccer-button--small-text">
      <span class="material-symbols-rounded">refresh</span>
    </button>
  </div>
  <div class="padding-24">
    <router-outlet></router-outlet>
  </div>
  <work-ui-environment-ribbon />
  <ng-template workUiAlertDialogs></ng-template>
  <ng-template workUiConfirmActionModalHost></ng-template>
  <ng-template workUiModal></ng-template>
</div>
